export enum NetworkNodeKind {
  Junction = 1,
  AccessPoint = 2,
  DeadEnd = 3,
}

export enum NetworkStatus {
  Draft = 1,
  Active = 2,
  Retired = 3,
}

export enum NetworkSource {
  Bootstrap = 1,
  Manual = 2,
  SurveyImport = 3,
}

export enum RoadClass {
  HaulPrimary = 1,
  HaulRamp = 2,
  BenchAccess = 3,
  ServiceRoad = 4,
  LightVehicleOnly = 5,
  Pedestrian = 6,
}

export enum RoadEventType {
  Closed = 1,
  Restricted = 2,
  SpeedLimit = 3,
  Degraded = 4,
}

export enum RoadEventSource {
  Manual = 1,
  BlastPlan = 2,
  System = 3,
}

export enum SiteNetworkLoadState {
  Loaded = 1,
  Empty = 2,
  NA = 3,
}

export enum GeofenceKind {
  LocationFootprint = 1,
  BlastExclusion = 2,
  RestrictedArea = 3,
  SpeedZone = 4,
  Gate = 5,
  SiteBoundary = 6,
}

export enum OffroadClusterStatus {
  Proposed = 1,
  Accepted = 2,
  Dismissed = 3,
}

export enum AnchorRole {
  Primary = 1,
  TipIn = 2,
  ServiceEntry = 3,
  Pickup = 4,
}

export enum SiteNetworkMachineClass {
  HaulTruck = 1,
  Excavator = 2,
  Grader = 3,
  WheelLoader = 4,
  LightVehicle = 5,
  Person = 6,
  Bus = 7,
}
